import React, { useState } from 'react';
import { Box, Button, keyframes } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import FolderIcon from '@mui/icons-material/Folder';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { useNavigate } from 'react-router-dom';
import { GettingStartedCard } from './GettingStartedCard';

const pulse = keyframes`
    0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(200, 50, 255, 1); }
    50% { transform: scale(1.06); box-shadow: 0 0 0 14px rgba(200, 50, 255, 0); }
    100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(200, 50, 255, 0); }
`;

interface QuickActionsProps {
    /** When true, the Get Started button pulses to attract attention */
    isNewUser?: boolean;
}

const QuickActions: React.FC<QuickActionsProps> = ({ isNewUser = false }) => {
    const navigate = useNavigate();
    const [gettingStartedOpen, setGettingStartedOpen] = useState(false);

    // Stop pulsing once the user has clicked the button
    const showPulse = isNewUser && !gettingStartedOpen;

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
            <Box data-testid="quick-actions" sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
                <Button
                    variant="contained"
                    startIcon={<RocketLaunchIcon />}
                    onClick={() => setGettingStartedOpen(!gettingStartedOpen)}
                    data-testid="quick-actions-get-started"
                    sx={showPulse ? { animation: `${pulse} 2.5s infinite` } : undefined}
                >
                    Get Started
                </Button>
                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={() => navigate('/create')}
                >
                    Create New Job
                </Button>
                <Button
                    variant="contained"
                    startIcon={<FolderIcon />}
                    onClick={() => navigate('/projects')}
                >
                    View Projects
                </Button>
            </Box>

            {/* Expandable Getting Started panel */}
            <Box sx={{ mt: 2, width: '100%', display: 'flex', justifyContent: 'center' }}>
                <GettingStartedCard
                    expanded={gettingStartedOpen}
                    onClose={() => setGettingStartedOpen(false)}
                />
            </Box>
        </Box>
    );
};

export default QuickActions;
